import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "./styles/styles.scss";
import "sweetalert/dist/sweetalert.css";

import * as Sentry from "@sentry/react";

import "./i18n";
import App from "./App";

// Initialize Sentry
Sentry.init({
  dsn: "https://6321a8741d2f43b55ee95f089426d1f9@o4508686537129984.ingest.de.sentry.io/4508686576517200",
  integrations: [
    Sentry.browserTracingIntegration({
      tracePropagationTargets: [
        "localhost:3001/admin",
        "localhost:3002",
        /^https:\/\/www\.artur2\.com\/invitations/,
        /^https:\/\/artur2\.com\/api/,
        /^https:\/\/www\.artur\.com\/invitations/,
        /^https:\/\/artur\.com\/api/,
      ],
    }),
    Sentry.replayIntegration({
      replaysSessionSampleRate: 0.1, // Capture 10% of sessions
      replaysOnErrorSampleRate: 1.0, // Always capture sessions with errors
    }),
  ],
  // Tracing configuration
  tracesSampleRate: 1.0, // Capture 100% of transactions
});

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred. Please try again later.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </QueryClientProvider>
);
